// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingWrapper":"PageHeading_pageHeadingWrapper__dQrd_","pageHeading":"PageHeading_pageHeading__7GxZ_"};